"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersService = void 0;
var tslib_1 = require("tslib");
var search_1 = require("src/search");
var FullTextSearchApi_1 = require("src/search/fullText/FullTextSearchApi");
var FilterableListService_1 = require("Views/Partials/Components/FilterableList/FilterableListService");
var filtersConfig_1 = require("../filtersConfig");
var BusinessRules_1 = require("./BusinessRules");
var SearchResultsService_1 = require("./SearchResultsService");
var FiltersService = /** @class */ (function () {
    function FiltersService() {
        var _this = this;
        this.prepareSelectedFilters = function (selectedFilters, serviceConfig, isDesktop, isDocumentsSearchPage, documentsSearchPageType, subsequentSearch) {
            // mobile filters - when clear all filters, url should contain only preselected values
            var shouldClearAllFiltersOnMobile = !isDesktop && selectedFilters.length === 0;
            if (shouldClearAllFiltersOnMobile || subsequentSearch) {
                return _this.getBrandNewSearchFilters(serviceConfig, isDocumentsSearchPage, documentsSearchPageType);
            }
            var resultingSelectedFilters = _this.getAllSelectedFilters(selectedFilters);
            resultingSelectedFilters = _this.processTypeFilter(resultingSelectedFilters, isDocumentsSearchPage, documentsSearchPageType);
            resultingSelectedFilters = _this.processHierarchyFilters(resultingSelectedFilters);
            resultingSelectedFilters = BusinessRules_1.BusinessRules.processPreSelectedRules(resultingSelectedFilters, {
                preselectedLanguagesDocuments: serviceConfig.preselectedLanguagesDocuments,
            });
            return resultingSelectedFilters;
        };
        this.removeFiltersWithoutValuesMobile = function (filters) {
            return filters.reduce(function (newFilters, filter) {
                var _ = filter.items, restProperties = tslib_1.__rest(filter, ["items"]);
                var items = filter.items;
                if (items && items.length > 0) {
                    if (filter.typeAlias === FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias) {
                        items = items.filter(function (item) {
                            return item && (item.documentsCount > 0 || item.selected);
                        });
                    }
                    newFilters.push(tslib_1.__assign({ items: items }, restProperties));
                }
                return newFilters;
            }, []);
        };
        this.filterOutFilterByKey = function (filters, key) {
            return filters.filter(function (f) { return SearchResultsService_1.SearchResultsService.getFilterKeyItself(f) !== key; });
        };
    }
    FiltersService.prototype.getBrandNewSearchFilters = function (serviceConfig, isDocumentsSearchPage, documentsSearchPageType) {
        var preselectedFiltersOnly = BusinessRules_1.BusinessRules.processPreSelectedRules([], {
            preselectedLanguagesDocuments: serviceConfig.preselectedLanguagesDocuments,
        }, true);
        return this.processTypeFilter(preselectedFiltersOnly, isDocumentsSearchPage, documentsSearchPageType);
    };
    FiltersService.prototype.getAllSelectedFilters = function (selectedFilters) {
        var selectedFiltersFromUrl = FilterableListService_1.FilterableListService.getFiltersFromUrl().filters;
        var prevTypeFilter = (0, search_1.getSelectedFilter)(selectedFiltersFromUrl, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias);
        var newTypeFilter = (0, search_1.getSelectedFilter)(selectedFilters, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias);
        var prevTypeValue = SearchResultsService_1.SearchResultsService.getFilterValueItself(prevTypeFilter);
        var newTypeValue = SearchResultsService_1.SearchResultsService.getFilterValueItself(newTypeFilter);
        var typeChanged = prevTypeValue !== newTypeValue;
        var selectedValuesFromUrlWithoutDuplicates = selectedFiltersFromUrl.filter(function (filterFromUrl) {
            var filterKey = SearchResultsService_1.SearchResultsService.getFilterKeyItself(filterFromUrl);
            return (filterKey !== FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias &&
                !selectedFilters.some(function (filter) { return SearchResultsService_1.SearchResultsService.getFilterKeyItself(filter) === filterKey; }));
        });
        var result = tslib_1.__spreadArray(tslib_1.__spreadArray([], selectedFilters, true), selectedValuesFromUrlWithoutDuplicates, true);
        if (!typeChanged) {
            result = this.filterOutClearedValues(newTypeValue, selectedValuesFromUrlWithoutDuplicates, selectedFilters, result);
        }
        return result;
    };
    FiltersService.prototype.filterOutClearedValues = function (typeValue, prevValues, newValues, filters) {
        var allFiltersOfType = filtersConfig_1.TYPE_TO_FILTER_MAPPING[typeValue] || filtersConfig_1.TYPE_TO_FILTER_MAPPING[FullTextSearchApi_1.FullTextSearcherTypes.All];
        var prevValuesKeys = prevValues.map(function (filter) {
            return SearchResultsService_1.SearchResultsService.getFilterKeyItself(filter);
        });
        var newValuesKeys = newValues.map(function (filter) { return SearchResultsService_1.SearchResultsService.getFilterKeyItself(filter); });
        var removedKeys = prevValuesKeys.filter(function (key) {
            return newValuesKeys.indexOf(key) === -1 && allFiltersOfType.indexOf(key) !== -1;
        });
        return filters.filter(function (filter) {
            var filterKey = SearchResultsService_1.SearchResultsService.getFilterKeyItself(filter);
            return removedKeys.indexOf(filterKey) === -1;
        });
    };
    FiltersService.prototype.processTypeFilter = function (selectedFilters, isDocumentsSearchPage, documentsSearchPageType) {
        if (!isDocumentsSearchPage)
            return selectedFilters;
        var newTypeFilter = (0, search_1.getSelectedFilter)(selectedFilters, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias);
        var newTypeValue = SearchResultsService_1.SearchResultsService.getFilterValueItself(newTypeFilter);
        // Forcing type to be documentation on documentation search page.
        if (!newTypeValue || newTypeValue !== documentsSearchPageType) {
            var defaultTypeFilter = "".concat(FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias, ":").concat(documentsSearchPageType);
            return tslib_1.__spreadArray([
                defaultTypeFilter
            ], this.filterOutFilterByKey(selectedFilters, FullTextSearchApi_1.FullTextSearchFilters.TypeFilterAlias), true);
        }
        return selectedFilters;
    };
    FiltersService.prototype.processHierarchyFilters = function (resultingSelectedFilters) {
        var _a = resultingSelectedFilters.reduce(function (acc, curr, index) {
            if (curr.indexOf(FullTextSearchApi_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias) === 0 &&
                curr.length > acc.longestDocumentationHierarchyLength) {
                acc.longestDocumentationHierarchyIndex = index;
                acc.longestDocumentationHierarchyLength = curr.length;
            }
            else if (curr.indexOf(FullTextSearchApi_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias) === 0 &&
                curr.length > acc.longestDocumentationProductHierarchyLength) {
                acc.longestDocumentationProductHierarchyIndex = index;
                acc.longestDocumentationProductHierarchyLength = curr.length;
            }
            else if (curr.indexOf(FullTextSearchApi_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias) === 0 &&
                curr.length > acc.longestDrawingsProductHierarchyLength) {
                acc.longestDrawingsProductHierarchyIndex = index;
                acc.longestDrawingsProductHierarchyLength = curr.length;
            }
            else if (curr.indexOf(FullTextSearchApi_1.FullTextSearchFilters.CourseHierarchyFilterAlias) === 0 &&
                curr.length > acc.longestCourseHierarchyLength) {
                acc.longestCourseHierarchyIndex = index;
                acc.longestCourseHierarchyLength = curr.length;
            }
            return acc;
        }, {
            longestDocumentationHierarchyIndex: -1,
            longestDocumentationHierarchyLength: 0,
            longestDocumentationProductHierarchyIndex: -1,
            longestDocumentationProductHierarchyLength: 0,
            longestDrawingsProductHierarchyIndex: -1,
            longestDrawingsProductHierarchyLength: 0,
            longestCourseHierarchyIndex: -1,
            longestCourseHierarchyLength: 0,
        }), longestDocumentationHierarchyIndex = _a.longestDocumentationHierarchyIndex, longestDocumentationProductHierarchyIndex = _a.longestDocumentationProductHierarchyIndex, longestDrawingsProductHierarchyIndex = _a.longestDrawingsProductHierarchyIndex, longestCourseHierarchyIndex = _a.longestCourseHierarchyIndex;
        return resultingSelectedFilters.filter(function (filter, index) {
            var isDocumentationHierarchyFilter = filter.indexOf(FullTextSearchApi_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias) !== -1;
            var isDocumentationProductHierarchyFilter = filter.indexOf(FullTextSearchApi_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias) !== -1;
            var isDrawingsProductHierarchyFilter = filter.indexOf(FullTextSearchApi_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias) !== -1;
            var isCourseHierarchyFilter = filter.indexOf(FullTextSearchApi_1.FullTextSearchFilters.CourseHierarchyFilterAlias) !== -1;
            return (!(isDocumentationHierarchyFilter && index !== longestDocumentationHierarchyIndex) &&
                !(isDocumentationProductHierarchyFilter &&
                    index !== longestDocumentationProductHierarchyIndex) &&
                !(isDrawingsProductHierarchyFilter && index !== longestDrawingsProductHierarchyIndex) &&
                !(isCourseHierarchyFilter && index !== longestCourseHierarchyIndex));
        });
    };
    return FiltersService;
}());
var service = new FiltersService();
exports.FiltersService = service;
